<template>
  <v-card flat color="grey-lighten-4">
    <v-card-title>{{ $t("components.AuthMethodsSelector.title") }}</v-card-title>
    <v-card-subtitle>{{ $t("components.AuthMethodsSelector.subtitle") }}</v-card-subtitle>
    <v-divider class="my-2"/>
    <v-card-text>
      <configuration-section-row v-for="(c, index) in methods" :key="index">
        <template #name>
          {{ $t(`components.AuthMethodsSelector.${index}`) }} {{ index }}
        </template>
        <labeled-switch
          v-model="methods[index]"
        />
      </configuration-section-row>
    </v-card-text>
    <v-card-actions>
      <v-spacer/>
      <v-btn
        color="secondary"
        @click="reset"
        :disabled="!changed"
      >
        {{ $t('buttons.reset') }}
      </v-btn>
      <v-btn
        color="primary"
        @click="confirmVisible = true"
        :disabled="!changed"
      >
        {{ $t('buttons.apply') }}
      </v-btn>
    </v-card-actions>
  </v-card>

  <div v-if="methods.azureAdb2c" class="mt-4">
    <azure-a-d-b2-c-config-form />
  </div>

  <div v-if="methods.sbOpenid" class="mt-4">
    <s-b-open-i-d-auth-config-form />
  </div>

  <confirm-dialog
    :title="$t('common.confirm_title')"
    :text="$t('common.confirm_text')"
    v-model="confirmVisible"
    @confirm="save"
    @cancel="confirmVisible = false"
  />
</template>
<script setup lang="ts">
import {useGlobalStore} from "@/store";
import {ref, computed} from "vue";
import ConfirmDialog from "@/components/ConfirmDialog.vue";
import {isEqual} from "lodash";
import LabeledSwitch from "@/components/LabeledSwitch.vue";
import {isYapiError, YapiError} from "@YenzaCT/sdk";
import {useI18n} from "vue-i18n";
import ConfigurationSectionRow from "@/pages/Settings/AppConfigurationPage/components/ConfigurationSectionRow.vue";
import AzureADB2CConfigForm from "@/pages/Settings/AppConfigurationPage/components/AzureADB2CConfigForm.vue";
import SBOpenIDAuthConfigForm from "@/pages/Settings/AppConfigurationPage/components/SBOpenIDAuthConfigForm.vue";

const store = useGlobalStore();

const confirmVisible = ref(false);
const {t} = useI18n();
const methods = ref({
  ...store.appConfiguration.authProviders
});

const changed = computed(() => !isEqual(store.appConfiguration.authProviders, methods.value));

function reset() {
  methods.value = {...store.appConfiguration.authProviders};
}

async function save() {
  try {
    await store.saveAppConfiguration("authProviders", methods.value);
    store.showSnackbar(t("components.AuthMethodsSelector.auth_providers_updated"));
    store.showSnackbar("Consent updated");
  } catch (e) {
    if (isYapiError(e)) {
      const yError = e as YapiError;
      await store.handleYapiError(yError);
    } else {
      throw e;
    }
  } finally {
    confirmVisible.value = false;
    reset();
  }
}
</script>

<style scoped>

</style>
